<template>
    <div class="net-body net-warning" v-loading="loading">
        <div class="net-body-head">
            <div class="net-head-label">
                <div class="labelBox">
                    {{ item.label }}
                </div>
                <div class="updateTimeTip" v-show="NWNData.w_insert_dt">更新时间：{{NWNData.w_insert_dt}}</div>
            </div>
            <el-popover
                placement="bottom"
                trigger="hover"
                popper-class="net-workbench-pop"
            >
                <!-- <div class="net-popover-css" @click="tomoreFn">更多</div> -->
                <div class="net-popover-css" @click="closeUp(item.prop)">关闭</div>
                <i slot="reference" class="el-icon-more i-style"></i>
            </el-popover>
        </div>
        <div class="net-content">
            <ul class="net-box">
                <li class="box-item" v-for="count in 3" :key="count">
                    <div class="item-label">超期{{count}}0天内
                        <el-tooltip
                            popper-class="net-warning-info-popper"
                            effect="light"
                            :content="warningInfo[count-1]"
                            placement="top"
                            :open-delay='300'
                            :visible-arrow="false">
                            <span class="el-icon-info"></span>
                        </el-tooltip>
                    </div>
                    <div class="item-vlue">{{NWNData['days_warning_'+count+'0']}}</div>
                    <el-button type="text" @click="checkData(jumpParam['days_warning_'+count+'0'])">查看全部</el-button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { getNetTablesInfo } from '../../../api/manaDesk.js';

export default {
    props: {
        item: {
            type: Object
        }
    },
    data() {
        return {
            loading: false,
            NWNData: {},
            startTime: dayjs().subtract(30, 'day').format('YYYY-MM-DD 00:00:00'),
            endTime: dayjs().format('YYYY-MM-DD 23:59:59'),
            warningInfo: [
                '当前日期 - 网点签收日期 <= 10日，最终预约日期 < 当前日期',
                `10日 < 当前日期 - 网点签收日期 <= 20日，最终预约日期 < 当前日期`,
                '20日 < 当前日期 - 网点签收日期 <= 30日'
            ],
            jumpParam: {
                days_warning_10: {
                    KanbanStatus: '1'
                },
                days_warning_20: {
                    KanbanStatus: '2'
                },
                days_warning_30: {
                    KanbanStatus: '3'
                }
            }
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            this.loading = true;
            const param = {
                type: 'cpkb_wdkb_cqyj',
                exportOrgId: "\"{'match_all':{}}\"",
                sourceType: 'es',
                nameMap: {
                    network_code: 'D20191223001',
                    network_center_code: 'D20201126001'
                },
                groupList: [
                    'network_code',
                    'network_center_code'
                ],
                logicalSymbolList: [
                    'or'
                ],
                refresh: true
            };
            await getNetTablesInfo(param).then(res => {
                if (res && res.code === '0') {
                    this.NWNData = {
                        days_warning_10: 0,
                        days_warning_20: 0,
                        days_warning_30: 0,
                        w_insert_dt: ''
                    };
                    if (!res.data.length) return;
                    res.data.forEach(item => {
                        this.NWNData.days_warning_10 += item.days_warning_10;
                        this.NWNData.days_warning_20 += item.days_warning_20;
                        this.NWNData.days_warning_30 += item.days_warning_30;
                        if (!this.NWNData.w_insert_dt && item.w_insert_dt) {
                            this.NWNData.w_insert_dt = item.w_insert_dt.split(' ')[1];
                        }
                    });
                }
            }).catch(() => {});
            this.$nextTick(() => {
                this.loading = false;
            });
        },
        // 跳转到网点任务管理页面
        checkData(params) {
            this.$router.push({
                query: {
                    ...params,
                    getData: true,
                    updateStartTime: this.startTime,
                    updateEndTime: this.endTime
                },
                path: '/net-task'
            });
        },
        closeUp() {
            this.$emit('closeUp', this.item.prop);
        },
        tomoreFn() {}
    }
};
</script>

<style lang="less">
.net-warning-info-popper {
    border: none !important;
    background-color: #f6ecf0 !important;
    color: #cd5d7d;
}
.net-warning {
    .box-item {
        display: flex;
        height: 72px;
        line-height: 72px;
        margin-bottom: 10px;
        background-color: #F8F8F9;
        .item-label {
            margin-left: 24px;
            font-size: 12px;
            color: #333;
            font-weight: 600;
        }
        .item-vlue {
            flex: 1;
            margin-left: 20px;
            overflow: auto;
            font-size: 18px;
            font-weight: 600;
        }
        .el-button {
            padding: 0 20px;
            font-size: 12px;
            color: #888;
            &:hover {
                color: #00bcbf;
                background: #ebfafa;
            }
        }

    }
    .box-item:first-child {
        border-left: 4px solid #FFC501;
        .item-vlue {
            color: #FFC501;
        }
    }
    .box-item:nth-child(2) {
        border-left: 4px solid #FF7500;
        .item-vlue {
            color: #FF7500;
        }
    }
    .box-item:last-child {
        border-left: 4px solid #FF0000;
        .item-vlue {
            color: #FF0000;
        }
    }
}
</style>